import Vue from "vue";
import VueRouter from "vue-router";
import MainPage from "@/views/MainPage";
import PlatformCreate from "@/views/PlatformCreate.vue";
import { authMiddleware } from "./middlewares/auth";
import { createPlatformMiddleware } from "./middlewares/createPlatform";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: MainPage,
  },
  {
    path: "/platform-create",
    name: "platform-create",
    component: PlatformCreate,
  },
  {
    path: "*",
    name: "NotFoundComponent",
    redirect: { name: "Home" },
  },
];
const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_ROOT_PREFIX,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach(createPlatformMiddleware);
router.beforeEach(authMiddleware);

export default router;
